/* src/app/recalculate-transactions/contracts-presenter/contracts-presenter.component.scss */
body#themeTag :host ::ng-deep .p-toolbar.p-component {
  height: 53.8px !important;
}
body#themeTag :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
  margin-left: -2px;
}
body#themeTag :host ::ng-deep .p-datatable .p-datatable-tbody > tr > td.p-datatable-cell {
  margin-top: 0 !important;
  margin-left: -2px;
}
/*# sourceMappingURL=contracts-presenter.component.css.map */
